import { useAppContext } from "@src/contexts/App/AppContext";
import { useState, useEffect } from 'react';

import Donut from "./UI/Donut";

import { Trans, t } from '@lingui/macro';

const ReportShort = () => {

    const [appState, AppActions] = useAppContext();

    let statistics = appState.statistics;

    return (
        <div>

            <div className="row align-items-center gx-5">
                <div className="col-lg-4 position-relative">
                    <div className="text-center  text-md-start mb-2 mb-md-0">
                        <Donut cleanerThan={statistics.score} />
                    </div>
                </div>
                <div className="col-lg-8">
                    <div className="fs-5 fw-bold">
                        Url: {statistics?.url}
                    </div>
                    <div className="fs-2 fw-bold">
                        <Trans> Green Web Meter score:</Trans> <span className="text-primary">{statistics?.score}%</span>
                    </div>
                    <div className="mb-2">
                        <div className="fs-5 fw-bold">
                            <Trans>Emissioni CO2 per visita</Trans>: <span className="text-primary">{statistics?.grams.toFixed(2)}g</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ReportShort;